export const VIBER_URL = "viber://chat?number=%2B306909418914";
export const WHATSAPP_URL = "https://wa.me/306909418914";
export const INSTAGRAM_URL = "https://instagram.com/mitrollari_engineering";
export const INSTAGRAM_HANDLE = "@mitrollari_engineering";
